import { render } from "./ChoiceSection.vue?vue&type=template&id=8eebb552&scoped=true"
import script from "./ChoiceSection.vue?vue&type=script&lang=js"
export * from "./ChoiceSection.vue?vue&type=script&lang=js"

import "./ChoiceSection.vue?vue&type=style&index=0&id=8eebb552&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eebb552"]])

export default __exports__